import { ActionType } from '@/actions/actiontypes';
import SimpleSelect from '@/components/objects/SimpleSelect';
import { MapProjeksjonToDisplayName, Projeksjon } from '@/domain/Projeksjon';
import { statePreferences } from '@/selectors/selectors';
import { ApiVersion } from '@/state';
import { ConfigAndDataContext } from '@/state/context/ConfigAndDataContext';
import { useDispatch, useSelector } from '@/state/store';
import { useVegnettUrls } from '@/utils/exportUtils';
import { getApiVersion } from '@/utils/Utils';
import { SVVButtonLink } from '@komponentkassen/svv-button';
import { SVVModal } from '@komponentkassen/svv-modal';
import * as React from 'react';
import { useContext, useEffect } from 'react';

interface ExportDialogProps {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    setDownloading: (downloading: boolean) => void;
    setDownloadUrl: (downloadUrl: string) => void;
}

interface SelectProps {
    name: string;
    label: string;
    options: string[];
    optionsDisplayMap?: Map<string, string>;
}

export const ExportDialog: React.FC<ExportDialogProps> = (exportDialogProps: ExportDialogProps) => {
    const { restapi_url_v3, restapi_url, eksport_url } = useContext(ConfigAndDataContext).config;
    const apiUrl = getApiVersion() === ApiVersion.V3 ? restapi_url_v3 : restapi_url;
    const { csv } = useVegnettUrls(apiUrl, eksport_url);

    const preferences = useSelector(statePreferences);
    const dispatch = useDispatch();

    useEffect(() => {
        exportDialogProps.setDownloadUrl(csv);
    }, [csv, exportDialogProps]);

    const handleSelect = (name: string, event: React.ChangeEvent<HTMLSelectElement>) => {
        dispatch({
            type: ActionType.PREFERENCES_UPDATE,
            [name]: event.target.value,
        });
    };

    const Select = ({ name, label, options, optionsDisplayMap }: SelectProps) => (
        <SimpleSelect
            label={label}
            options={options}
            optionLabel={optionsDisplayMap ? option => optionsDisplayMap.get(option) : undefined}
            value={preferences[name]}
            onChange={e => handleSelect(name, e)}
        />
    );

    return (
        <>
            <SVVModal
                show={exportDialogProps.isOpen}
                onClose={() => exportDialogProps.setIsOpen(false)}
                title={'Eksporter datasett'}
                acceptButton={
                    <SVVButtonLink
                        className="c-results-summary-export-links__download svv-knapp"
                        onClick={() => exportDialogProps.setDownloading(true)}
                        href={csv}
                    >
                        Last ned som CSV
                    </SVVButtonLink>
                }
            >
                <div className="c-preferences-toggle-content">
                    <Select
                        name="exportProjection"
                        label="Velg kartprojeksjon"
                        options={Object.values(Projeksjon)}
                        optionsDisplayMap={MapProjeksjonToDisplayName}
                    />
                </div>
            </SVVModal>
        </>
    );
};

export default ExportDialog;
